import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import {useModal, useSettings} from "../../store";
import BuyAwards from "./buy_awards";
import ConfirmAward from "./confirm_award";
import {themecolors} from "../../utils/themecolors";

const Description = styled.div``;
const Quantity = styled.div``;
const Heading = styled.div``;

const GiveAward = styled(({className, onClose, id, type}) => {
    const {available_awards} = useSettings();
    const modal = useModal();
    const handleContinue = async () => {
        onClose();
        if (available_awards === 0) {
            modal.open(BuyAwards);
        } else {
            modal.open(ConfirmAward, {id, type});
            // modal.open(PayWithCard, {type: 'award', awards: 1});
        }
    }
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Give Award</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6} className={className}>
                    <Description>Awarding a post will help it attract more attention, and will grant the author a week of Scored Pro.</Description>
                    <Heading>Award Credits</Heading>
                    <Quantity>
                        {available_awards === 0 ?
                        "You don't have any award credits."
                        :
                        `${available_awards}`
                    }
                    </Quantity>
                </ModalBody>

                <ModalFooter>

                    <Button variant="cancel" mr={3} onClick={onClose}>Close</Button>
                    <Button type='submit' variant="blue" onClick={handleContinue}>
                        {available_awards === 0 ? 'Buy' : 'Give Award'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
    ${Description} {
      margin-bottom: 6px;
    }
  ${Quantity} {
    padding-top: 2px;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Heading} {
    margin-top: 16px;
    font-weight: 500;
    font-size: 16px;
  }
`;

export default GiveAward;
